<template>
  <img :src="imageSrc" v-bind="$attrs" class="loading">
</template>

<script setup lang="ts">
import { useBrand } from '@/composables/useBrand';
import { computed } from 'vue';

const { isSicuraSolution } = useBrand();

const imageSrc = computed(() => {
  if (isSicuraSolution.value) return env.VUE_APP_SICURASOLUTION_LOGO_LAUNCHER || env.VUE_APP_SICURASOLUTION_LOGO_MINI;
  return env.VUE_APP_AMMINISTROIO_LOGO_LAUNCHER || env.VUE_APP_AMMINISTROIO_LOGO_MINI;
});
</script>
<style scoped>
.loading {
  object-fit: contain;
  width: 65px;
  height: 65px;
}
</style>
